(() => {
  'use strict';
  const endpoint = 'https://script.google.com/macros/s/AKfycbyoqat2XXTGB8fcpFxF3ZLkwfJj-MobFtcqxhxcdDEbpLQa2QchfpoErnfz18IulOSk/exec';
  const maxBytes = 10 * 1024 * 1024;
  const maxFiles = 5;
  const types = {
    jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp',
    gif: 'image/gif', heic: 'image/heic', heif: 'image/heif', avif:'image/avif',
    tif:'image/tiff', tiff:'image/tiff', pdf: 'application/pdf',
    doc: 'application/msword', docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xls: 'application/vnd.ms-excel', xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    txt: 'text/plain', csv: 'text/csv', zip: 'application/zip'
  };
  const start = () => {
    const form = document.getElementById('ArutehasContactForm');
    const messageGroup = document.getElementById('MessageInputGroup');
    const submit = document.getElementById('SubmitBtn');
    const area = document.getElementById('ArutehasAttachments');
    const translations = document.getElementById('ArutehasAttachmentTranslations');
    if (!form || !messageGroup || !submit || !area || !translations || area.dataset.initialized) return;
    let copy;
    try { copy = JSON.parse(translations.textContent); } catch (_) { return; }
    const drop = area.querySelector('.ar-attachment-drop');
    const input = area.querySelector('input');
    const list = area.querySelector('ul');
    const errorBox = area.querySelector('.ar-attachment-error');
    if (!drop || !input || !list || !errorBox) return;
    area.dataset.initialized = 'true';
    messageGroup.after(area);
    area.hidden = false;
    input.accept = Object.keys(types).map(extension => '.' + extension).join(',');
    let files = [];
    let sending = false;
    let attempt = null;
    let dragDepth = 0;
    const error = text => {
      errorBox.textContent = text;
      errorBox.hidden = !text;
    };
    const renderFiles = () => {
      list.replaceChildren();
      files.forEach((file, index) => {
        const item = document.createElement('li');
        item.className = 'ar-attachment-file';
        const name = document.createElement('span');
        name.className = 'ar-attachment-name';
        name.textContent = file.name;
        name.title = file.name;
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'ar-attachment-remove';
        remove.textContent = '×';
        remove.setAttribute('aria-label', copy.remove_label + ' ' + file.name);
        remove.addEventListener('click', () => {
          if (sending) return;
          files.splice(index, 1);
          attempt = null;
          error('');
          renderFiles();
        });
        item.append(name, remove);
        list.append(item);
      });
    };
    const addFiles = incoming => {
      if (sending) return;
      const next = [...files];
      for (const file of incoming) {
        const extension = file.name.split('.').pop().toLowerCase();
        if (!types[extension]) { error(copy.unsupported_add); return; }
        if (!file.size) { error(copy.empty_file); return; }
        if (file.name.length > 180 || /[\u0000-\u001f\u007f]/.test(file.name)) { error(copy.invalid_filename); return; }
        if (next.some(existing => existing.name === file.name && existing.size === file.size && existing.lastModified === file.lastModified)) continue;
        next.push(file);
      }
      if (next.length > maxFiles) { error(copy.file_limit); return; }
      if (next.reduce((sum, file) => sum + file.size, 0) > maxBytes) { error(copy.file_size); return; }
      if (next.length === files.length) { error(''); return; }
      files = next;
      attempt = null;
      error('');
      renderFiles();
    };
    drop.addEventListener('click', () => input.click());
    input.addEventListener('change', () => { addFiles(Array.from(input.files)); input.value = ''; });
    area.addEventListener('dragenter', event => {
      if (!Array.from(event.dataTransfer?.types || []).includes('Files')) return;
      event.preventDefault();
      dragDepth++;
      area.classList.add('is-dragging');
    });
    area.addEventListener('dragover', event => {
      if (!Array.from(event.dataTransfer?.types || []).includes('Files')) return;
      event.preventDefault();
      event.dataTransfer.dropEffect = sending ? 'none' : 'copy';
    });
    area.addEventListener('dragleave', () => { if (--dragDepth <= 0) { dragDepth = 0; area.classList.remove('is-dragging'); } });
    area.addEventListener('drop', event => {
      event.preventDefault();
      dragDepth = 0;
      area.classList.remove('is-dragging');
      addFiles(Array.from(event.dataTransfer?.files || []));
    });
    const readFile = file => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve({name:file.name,mimeType:types[file.name.split('.').pop().toLowerCase()],base64:String(reader.result).split(',')[1]});
      reader.onerror = () => reject(new Error(copy.read_failed));
      reader.readAsDataURL(file);
    });
    const value = id => document.getElementById(id)?.value.trim() || '';
    const randomToken = () => Array.from(crypto.getRandomValues(new Uint8Array(24)), byte => byte.toString(16).padStart(2, '0')).join('');
    const post = payload => new Promise((resolve, reject) => {
      const frame = document.createElement('iframe');
      const transport = document.createElement('form');
      const data = document.createElement('input');
      let settled = false;
      let timer;
      const finish = failure => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        window.removeEventListener('message', receive);
        transport.remove();
        frame.remove();
        failure ? reject(new Error(failure)) : resolve();
      };
      const receive = event => {
        if (!/^https:\/\/(?:(?:[a-z0-9-]+\.)?script|[a-z0-9-]+-script)\.googleusercontent\.com$/.test(event.origin)) return;
        const result = event.data;
        if (!result || result.type !== 'arutehas-contact-attachments' || result.requestId !== payload.requestId || result.nonce !== payload.nonce) return;
        finish(result.ok === true ? '' : (copy[String(result.error || '').toLowerCase()] || copy.send_failed));
      };
      frame.name = 'arutehas_attachment_' + payload.nonce;
      frame.title = copy.transport_title;
      frame.hidden = true;
      transport.method = 'POST';
      transport.action = endpoint;
      transport.target = frame.name;
      transport.hidden = true;
      data.type = 'hidden';
      data.name = 'payload';
      data.value = JSON.stringify(payload);
      transport.append(data);
      window.addEventListener('message', receive);
      document.body.append(frame, transport);
      timer = setTimeout(() => finish(copy.timeout), 90000);
      transport.submit();
    });
    form.addEventListener('submit', async event => {
      if (!files.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (sending || !form.reportValidity()) return;
      if (value('ContactFormBotCatch')) return;
      if (!/^https:\/\/script\.google\.com\/macros\/s\/[^/]+\/exec$/.test(endpoint)) { error(copy.not_connected); return; }
      const fields = {name:value('ContactFormName'),email:value('ContactFormEmail'),phone:value('ContactFormPhone'),address:value('ContactFormAddress'),message:value('ContactFormMessage'),website:value('ContactFormBotCatch')};
      const signature = JSON.stringify([fields,files.map(file => [file.name,file.size,file.lastModified])]);
      if (!attempt || attempt.signature !== signature) attempt = {signature,requestId:crypto.randomUUID(),nonce:randomToken()};
      const lockedControls = Array.from(document.querySelectorAll('#ArutehasContactForm input,#ArutehasContactForm textarea,#ArutehasContactForm select,#ArutehasContactForm button,#CartVisualPreview input,#CartVisualPreview select,#CartVisualPreview button,#FinishingServiceBox select')).map(element => ({element,disabled:element.disabled}));
      const lockedAreas = ['CartVisualPreview','FinishingServiceBox'].map(id => document.getElementById(id)).filter(Boolean).map(element => ({element,pointerEvents:element.style.pointerEvents}));
      let originalCart, originalFinishing;
      try {
        originalCart = localStorage.getItem('arutehas_cart');
        originalFinishing = localStorage.getItem('arutehas_finishing_services');
      } catch (_) {}
      let sheetSnapshot;
      try {
        if (typeof salvestaSheetsiOotele === 'function' && typeof SHEETS_PENDING_KEY === 'string') {
          salvestaSheetsiOotele();
          sheetSnapshot = localStorage.getItem(SHEETS_PENDING_KEY);
          localStorage.removeItem(SHEETS_PENDING_KEY);
        }
      } catch (_) {}
      lockedControls.forEach(({element}) => { element.disabled = true; });
      lockedAreas.forEach(({element}) => { element.style.pointerEvents = 'none'; });
      sending = true;
      submit.disabled = true;
      area.classList.add('is-sending');
      form.setAttribute('aria-busy', 'true');
      error('');
      const buttonText = submit.querySelector('.btn-text');
      const originalButtonText = buttonText?.textContent;
      if (buttonText) buttonText.textContent = copy.sending;
      let accepted = false;
      try {
        const encoded = await Promise.all(files.map(readFile));
        await post({action:'arutehasContactAttachmentsV1',requestId:attempt.requestId,nonce:attempt.nonce,origin:location.origin,...fields,files:encoded});
        accepted = true;
        try {
          if (sheetSnapshot && typeof SHEETS_PENDING_KEY === 'string' && typeof saadaSheetsi === 'function') {
            localStorage.setItem(SHEETS_PENDING_KEY, sheetSnapshot);
            saadaSheetsi();
          }
        } catch (_) {}
        try {
          if (localStorage.getItem('arutehas_cart') === originalCart && localStorage.getItem('arutehas_finishing_services') === originalFinishing) {
            localStorage.removeItem('arutehas_cart');
            localStorage.removeItem('arutehas_finishing_services');
          }
        } catch (_) {}
        files = [];
        attempt = null;
        renderFiles();
        form.reset();
        try { if (typeof renderCartContent === 'function') renderCartContent(); } catch (_) {}
        const success = document.createElement('div');
        success.className = 'form-success-message';
        success.setAttribute('role', 'status');
        success.textContent = copy.success;
        form.querySelector('.form-success-message')?.remove();
        form.prepend(success);
        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
        window.gtag('event','conversion',{'send_to':'AW-18409259633/PdMKCPH7uOccEPGEnMpE',value:1.0,currency:'EUR'});
        success.scrollIntoView({behavior:'smooth',block:'center'});
      } catch (failure) {
        if (!accepted) error(failure.message || copy.failed_preserved);
      } finally {
        sending = false;
        lockedControls.forEach(({element,disabled}) => { element.disabled = disabled; });
        lockedAreas.forEach(({element,pointerEvents}) => { element.style.pointerEvents = pointerEvents; });
        form.removeAttribute('aria-busy');
        area.classList.remove('is-sending');
        if (buttonText) buttonText.textContent = originalButtonText;
      }
    }, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
